import { render, staticRenderFns } from "./Retrievepassword.vue?vue&type=template&id=05f3a2ef&"
import script from "./Retrievepassword.vue?vue&type=script&lang=js&"
export * from "./Retrievepassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports